module.exports = __webpack_public_path__ + "static/media/deposit-receipt.ea2c9dc7.png";